import ApiService from "@/common/api.service"

export const HealthProfessionService = {
    create(params) {
        return ApiService.post("healthProfessions/add", params);
    },
    update(slug, params) {
        return ApiService.update("healthProfessions", slug, params);
    },

}